const toggleSelector = '[data-pbc-shop-toggle]';
const shopSelector = '.pbc-desktop-nav__shop';
let hoverTimer;
let closeTimer;
let pinnedShop;

function closeShop(shop) {
  if (!(shop instanceof HTMLElement)) return;
  window.clearTimeout(hoverTimer);
  window.clearTimeout(closeTimer);
  if (pinnedShop === shop) pinnedShop = undefined;

  const button = shop.querySelector(toggleSelector);
  const panel = shop.querySelector('[data-pbc-shop-panel]');
  const header = shop.closest('header-component');

  shop.classList.remove('pbc-desktop-nav__shop--open');
  button?.setAttribute('aria-expanded', 'false');
  if (panel instanceof HTMLElement) panel.inert = true;
  header?.style.setProperty('--submenu-height', '0px');
  header?.style.setProperty('--full-open-header-height', '0px');
}

function openShop(shop) {
  if (!(shop instanceof HTMLElement) || window.innerWidth < 750) return;

  const button = shop.querySelector(toggleSelector);
  const panel = shop.querySelector('[data-pbc-shop-panel]');
  const header = shop.closest('header-component');

  shop.classList.add('pbc-desktop-nav__shop--open');
  button?.setAttribute('aria-expanded', 'true');
  if (panel instanceof HTMLElement) panel.inert = false;

  requestAnimationFrame(() => {
    if (!(panel instanceof HTMLElement) || !(header instanceof HTMLElement) || !shop.classList.contains('pbc-desktop-nav__shop--open')) return;
    const submenuHeight = panel.offsetHeight;
    header.style.setProperty('--submenu-height', `${submenuHeight}px`);
    header.style.setProperty('--full-open-header-height', `${submenuHeight + header.offsetHeight}px`);
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(toggleSelector);
  const openShopElement = document.querySelector(`${shopSelector}.pbc-desktop-nav__shop--open`);

  if (button) {
    window.clearTimeout(hoverTimer);
    window.clearTimeout(closeTimer);
    const shop = button.closest(shopSelector);
    if (pinnedShop === shop) {
      closeShop(shop);
    } else {
      if (openShopElement !== shop) closeShop(openShopElement);
      openShop(shop);
      pinnedShop = shop;
    }
    return;
  }

  if (openShopElement && !openShopElement.contains(event.target)) closeShop(openShopElement);
});

document.addEventListener('pointerover', (event) => {
  if (event.pointerType === 'touch') return;
  if (!(event.target instanceof Element)) return;
  const shop = event.target.closest(shopSelector);
  if (!shop || (event.relatedTarget instanceof Node && shop.contains(event.relatedTarget))) return;
  window.clearTimeout(hoverTimer);
  window.clearTimeout(closeTimer);
  hoverTimer = window.setTimeout(() => openShop(shop), 150);
});

document.addEventListener('pointerout', (event) => {
  if (!(event.target instanceof Element)) return;
  const shop = event.target.closest(shopSelector);
  if (!shop || (event.relatedTarget instanceof Node && shop.contains(event.relatedTarget))) return;
  window.clearTimeout(hoverTimer);
  window.clearTimeout(closeTimer);
  if (pinnedShop === shop) return;
  // Allow the pointer to cross the header-to-panel gap, including diagonally.
  closeTimer = window.setTimeout(() => closeShop(shop), 400);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const shop = document.querySelector(`${shopSelector}.pbc-desktop-nav__shop--open`);
  if (!shop) return;
  const button = shop.querySelector(toggleSelector);
  closeShop(shop);
  if (button instanceof HTMLElement) button.focus();
});
